import { CheckCircle2, X } from 'lucide-react'
import useAppStore from '@/store/useAppStore'
import useAuthStore from '@/store/useAuthStore'
import { RESET_SUCCESS_BANNER } from '@/pages/account/spaceResetCopy'

/**
 * Shown after a space data reset (14zfmu11ywd) until dismissed, only in the
 * space that was reset.
 */
export default function SpaceResetBanner() {
  const currentTeamId = useAuthStore((s) => s.currentTeamId)
  const bannerTeamId = useAppStore((s) => s.spaceResetBannerTeamId)
  const setBannerTeamId = useAppStore((s) => s.setSpaceResetBannerTeamId)

  if (!bannerTeamId || String(bannerTeamId) !== String(currentTeamId))
    return null

  return (
    <div
      role="status"
      className="flex min-w-0 items-center gap-3 border-b border-green-200 bg-green-50 px-3 py-1.5 text-sm text-green-900"
    >
      <CheckCircle2 className="size-4 shrink-0" />
      <span className="min-w-0 flex-1">{RESET_SUCCESS_BANNER}</span>
      <button
        type="button"
        aria-label="Dismiss"
        className="shrink-0 rounded p-0.5 hover:bg-green-100"
        onClick={() => setBannerTeamId(null)}
      >
        <X className="size-4" />
      </button>
    </div>
  )
}
